export default "__VITE_ASSET__67eb489f__"